import { useVerifyMutation, useResendCodeMutation } from 'util/rtk-api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { showToast } from 'components/toast'
import { showMutationError } from 'util/mutation-error'
import { AuthCard, AuthDivider } from 'auth/auth-card'

export const Verification = () => {
	const searchParams = new URLSearchParams(window.location.search)
	const email = searchParams.get('email')
	const navigate = useNavigate()
	const [ verify ] = useVerifyMutation()
	const [ resendCode ] = useResendCodeMutation()

	const [ code, setCode ] = useState('')

	// The code is read as it is typed (it used to be read only when the box lost focus, so pressing
	// Enter straight after typing could send nothing); validity is re-checked on every change.
	const checkCode = target => {
		if (
			target.value.match(/\d{6}/)
		) {
			target.setCustomValidity('')
			return
		}
		
		target.setCustomValidity(
			'The pin should be a 6-digit number.'
		)
	}

	const onFormSubmit = async event => {
		event.preventDefault()

		const result = await verify({ username: email, confirmationCode: code })

		if (showMutationError(result, 'The verification code was not accepted. Please try again.')) return

		navigate('/login')
	}

	const onResendLinkClick = async () => {
		const result = await resendCode({ username: email })

		if (showMutationError(result)) return

		showToast(`A new code has been sent to ${email}`, "success")
	}

	useDocTitle('All for One - Verification Code')

	return (
		<AuthCard
			eyebrow="Check your email"
			title="Enter verification code"
			subtitle={<>You’ll get an email at {email} if it’s linked to your account.</>}
		>
			<form
				id="verification-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="auth-field">
					<label htmlFor="code" className="auth-field-label">Verification code</label>
					<input
						type="tel"
						id="code"
						name="code"
						placeholder="6-digit code"
						required
						value={code}
						onChange={({ target }) => { setCode(target.value); checkCode(target) }}
					/>
				</div>

				<button type="submit" className="auth-btn">Next</button>
			</form>

			<p className="auth-prompt auth-prompt--spaced">
				Did not receive the email? Check your spam filter or{' '}
				<Link
					to={window.location}
					id="resend-link"
					className="auth-link"
					onClick={onResendLinkClick}
				>
					Resend code
				</Link>
			</p>

			<AuthDivider />

			<p className="auth-prompt">
				Remembered your password? <Link to="/login" className="auth-link">Log in</Link>
			</p>
		</AuthCard>
	)
}
